import { default as invite05N2iyzI7KMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/admin/invite.vue?macro=true";
import { default as uploadxIF3JxljhrMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/admin/upload.vue?macro=true";
import { default as usersHEAvE44XOCMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/admin/users.vue?macro=true";
import { default as _91id_93HSQbD9lZ9XMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/camera-roll/[id].vue?macro=true";
import { default as camera_45rollsFcxcrn3jK3Meta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/camera-rolls.vue?macro=true";
import { default as confirmation_45successDuSEkdwFJ6Meta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/confirmation-success.vue?macro=true";
import { default as aboutS8n9WL17SwMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/about.vue?macro=true";
import { default as demov1fJJRg3yiMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/demo.vue?macro=true";
import { default as emailtemplateVeQ3owBsvJMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/emailtemplate.vue?macro=true";
import { default as mediaq51qB1AaNQMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/media.vue?macro=true";
import { default as passwordlessIVzDX1wezoMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/passwordless.vue?macro=true";
import { default as qrscanGAfXS6ypCjMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/qrscan.vue?macro=true";
import { default as testvi9nhgC5DbMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/test.vue?macro=true";
import { default as devtools5cOQqEK57EMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/devtools.vue?macro=true";
import { default as email_45actionsuzcZdvKuiDMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/email-actions.vue?macro=true";
import { default as guestYYbN8M87N2Meta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/guest.vue?macro=true";
import { default as indexHkOtkgdTJFMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/index.vue?macro=true";
import { default as login5X3BLDSVUfMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/login.vue?macro=true";
import { default as logoutIx5tHFrleNMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/logout.vue?macro=true";
import { default as passwordlessmULP7Q0r1ZMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/passwordless.vue?macro=true";
import { default as previewxN3RiOX1MtMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/preview.vue?macro=true";
import { default as printable_45qrcoderzZLtm5HG3Meta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/printable-qrcode.vue?macro=true";
import { default as privacyE7gWFggMNMMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/privacy.vue?macro=true";
import { default as aboutzincMfAWZ9Meta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/about.vue?macro=true";
import { default as change_45passwordg8LLVckESDMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/change-password.vue?macro=true";
import { default as deleteaccountBnCjo9idmZMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/deleteaccount.vue?macro=true";
import { default as indexxwIcJaofu6Meta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/index.vue?macro=true";
import { default as language_45switchs0hyEDi44dMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/language-switch.vue?macro=true";
import { default as profile_45basics3Cwn3bevgGMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/profile-basics.vue?macro=true";
import { default as qrscan_45insideBY5Klx9iVvMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/qrscan-inside.vue?macro=true";
import { default as register8FkDhkxA2PMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/register.vue?macro=true";
import { default as startsYhkcPakvKMeta } from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/start.vue?macro=true";
export default [
  {
    name: invite05N2iyzI7KMeta?.name ?? "admin-invite",
    path: invite05N2iyzI7KMeta?.path ?? "/admin/invite",
    meta: invite05N2iyzI7KMeta || {},
    alias: invite05N2iyzI7KMeta?.alias || [],
    redirect: invite05N2iyzI7KMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/admin/invite.vue").then(m => m.default || m)
  },
  {
    name: uploadxIF3JxljhrMeta?.name ?? "admin-upload",
    path: uploadxIF3JxljhrMeta?.path ?? "/admin/upload",
    meta: uploadxIF3JxljhrMeta || {},
    alias: uploadxIF3JxljhrMeta?.alias || [],
    redirect: uploadxIF3JxljhrMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/admin/upload.vue").then(m => m.default || m)
  },
  {
    name: usersHEAvE44XOCMeta?.name ?? "admin-users",
    path: usersHEAvE44XOCMeta?.path ?? "/admin/users",
    meta: usersHEAvE44XOCMeta || {},
    alias: usersHEAvE44XOCMeta?.alias || [],
    redirect: usersHEAvE44XOCMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: _91id_93HSQbD9lZ9XMeta?.name ?? "camera-roll-id",
    path: _91id_93HSQbD9lZ9XMeta?.path ?? "/camera-roll/:id()",
    meta: _91id_93HSQbD9lZ9XMeta || {},
    alias: _91id_93HSQbD9lZ9XMeta?.alias || [],
    redirect: _91id_93HSQbD9lZ9XMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/camera-roll/[id].vue").then(m => m.default || m)
  },
  {
    name: camera_45rollsFcxcrn3jK3Meta?.name ?? "camera-rolls",
    path: camera_45rollsFcxcrn3jK3Meta?.path ?? "/camera-rolls",
    meta: camera_45rollsFcxcrn3jK3Meta || {},
    alias: camera_45rollsFcxcrn3jK3Meta?.alias || [],
    redirect: camera_45rollsFcxcrn3jK3Meta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/camera-rolls.vue").then(m => m.default || m)
  },
  {
    name: confirmation_45successDuSEkdwFJ6Meta?.name ?? "confirmation-success",
    path: confirmation_45successDuSEkdwFJ6Meta?.path ?? "/confirmation-success",
    meta: confirmation_45successDuSEkdwFJ6Meta || {},
    alias: confirmation_45successDuSEkdwFJ6Meta?.alias || [],
    redirect: confirmation_45successDuSEkdwFJ6Meta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/confirmation-success.vue").then(m => m.default || m)
  },
  {
    name: aboutS8n9WL17SwMeta?.name ?? "dev-about",
    path: aboutS8n9WL17SwMeta?.path ?? "/dev/about",
    meta: aboutS8n9WL17SwMeta || {},
    alias: aboutS8n9WL17SwMeta?.alias || [],
    redirect: aboutS8n9WL17SwMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/about.vue").then(m => m.default || m)
  },
  {
    name: demov1fJJRg3yiMeta?.name ?? "dev-demo",
    path: demov1fJJRg3yiMeta?.path ?? "/dev/demo",
    meta: demov1fJJRg3yiMeta || {},
    alias: demov1fJJRg3yiMeta?.alias || [],
    redirect: demov1fJJRg3yiMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/demo.vue").then(m => m.default || m)
  },
  {
    name: emailtemplateVeQ3owBsvJMeta?.name ?? "dev-emailtemplate",
    path: emailtemplateVeQ3owBsvJMeta?.path ?? "/dev/emailtemplate",
    meta: emailtemplateVeQ3owBsvJMeta || {},
    alias: emailtemplateVeQ3owBsvJMeta?.alias || [],
    redirect: emailtemplateVeQ3owBsvJMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/emailtemplate.vue").then(m => m.default || m)
  },
  {
    name: mediaq51qB1AaNQMeta?.name ?? "dev-media",
    path: mediaq51qB1AaNQMeta?.path ?? "/dev/media",
    meta: mediaq51qB1AaNQMeta || {},
    alias: mediaq51qB1AaNQMeta?.alias || [],
    redirect: mediaq51qB1AaNQMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/media.vue").then(m => m.default || m)
  },
  {
    name: passwordlessIVzDX1wezoMeta?.name ?? "dev-passwordless",
    path: passwordlessIVzDX1wezoMeta?.path ?? "/dev/passwordless",
    meta: passwordlessIVzDX1wezoMeta || {},
    alias: passwordlessIVzDX1wezoMeta?.alias || [],
    redirect: passwordlessIVzDX1wezoMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/passwordless.vue").then(m => m.default || m)
  },
  {
    name: qrscanGAfXS6ypCjMeta?.name ?? "dev-qrscan",
    path: qrscanGAfXS6ypCjMeta?.path ?? "/dev/qrscan",
    meta: qrscanGAfXS6ypCjMeta || {},
    alias: qrscanGAfXS6ypCjMeta?.alias || [],
    redirect: qrscanGAfXS6ypCjMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/qrscan.vue").then(m => m.default || m)
  },
  {
    name: testvi9nhgC5DbMeta?.name ?? "dev-test",
    path: testvi9nhgC5DbMeta?.path ?? "/dev/test",
    meta: testvi9nhgC5DbMeta || {},
    alias: testvi9nhgC5DbMeta?.alias || [],
    redirect: testvi9nhgC5DbMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/dev/test.vue").then(m => m.default || m)
  },
  {
    name: devtools5cOQqEK57EMeta?.name ?? "devtools",
    path: devtools5cOQqEK57EMeta?.path ?? "/devtools",
    meta: devtools5cOQqEK57EMeta || {},
    alias: devtools5cOQqEK57EMeta?.alias || [],
    redirect: devtools5cOQqEK57EMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/devtools.vue").then(m => m.default || m)
  },
  {
    name: email_45actionsuzcZdvKuiDMeta?.name ?? "email-actions",
    path: email_45actionsuzcZdvKuiDMeta?.path ?? "/email-actions",
    meta: email_45actionsuzcZdvKuiDMeta || {},
    alias: email_45actionsuzcZdvKuiDMeta?.alias || [],
    redirect: email_45actionsuzcZdvKuiDMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/email-actions.vue").then(m => m.default || m)
  },
  {
    name: guestYYbN8M87N2Meta?.name ?? "guest",
    path: guestYYbN8M87N2Meta?.path ?? "/guest",
    meta: guestYYbN8M87N2Meta || {},
    alias: guestYYbN8M87N2Meta?.alias || [],
    redirect: guestYYbN8M87N2Meta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/guest.vue").then(m => m.default || m)
  },
  {
    name: indexHkOtkgdTJFMeta?.name ?? "index",
    path: indexHkOtkgdTJFMeta?.path ?? "/",
    meta: indexHkOtkgdTJFMeta || {},
    alias: indexHkOtkgdTJFMeta?.alias || [],
    redirect: indexHkOtkgdTJFMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/index.vue").then(m => m.default || m)
  },
  {
    name: login5X3BLDSVUfMeta?.name ?? "login",
    path: login5X3BLDSVUfMeta?.path ?? "/login",
    meta: login5X3BLDSVUfMeta || {},
    alias: login5X3BLDSVUfMeta?.alias || [],
    redirect: login5X3BLDSVUfMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/login.vue").then(m => m.default || m)
  },
  {
    name: logoutIx5tHFrleNMeta?.name ?? "logout",
    path: logoutIx5tHFrleNMeta?.path ?? "/logout",
    meta: logoutIx5tHFrleNMeta || {},
    alias: logoutIx5tHFrleNMeta?.alias || [],
    redirect: logoutIx5tHFrleNMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: passwordlessmULP7Q0r1ZMeta?.name ?? "passwordless",
    path: passwordlessmULP7Q0r1ZMeta?.path ?? "/passwordless",
    meta: passwordlessmULP7Q0r1ZMeta || {},
    alias: passwordlessmULP7Q0r1ZMeta?.alias || [],
    redirect: passwordlessmULP7Q0r1ZMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/passwordless.vue").then(m => m.default || m)
  },
  {
    name: previewxN3RiOX1MtMeta?.name ?? "preview",
    path: previewxN3RiOX1MtMeta?.path ?? "/preview",
    meta: previewxN3RiOX1MtMeta || {},
    alias: previewxN3RiOX1MtMeta?.alias || [],
    redirect: previewxN3RiOX1MtMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/preview.vue").then(m => m.default || m)
  },
  {
    name: printable_45qrcoderzZLtm5HG3Meta?.name ?? "printable-qrcode",
    path: printable_45qrcoderzZLtm5HG3Meta?.path ?? "/printable-qrcode",
    meta: printable_45qrcoderzZLtm5HG3Meta || {},
    alias: printable_45qrcoderzZLtm5HG3Meta?.alias || [],
    redirect: printable_45qrcoderzZLtm5HG3Meta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/printable-qrcode.vue").then(m => m.default || m)
  },
  {
    name: privacyE7gWFggMNMMeta?.name ?? "privacy",
    path: privacyE7gWFggMNMMeta?.path ?? "/privacy",
    meta: privacyE7gWFggMNMMeta || {},
    alias: privacyE7gWFggMNMMeta?.alias || [],
    redirect: privacyE7gWFggMNMMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: aboutzincMfAWZ9Meta?.name ?? "profile-about",
    path: aboutzincMfAWZ9Meta?.path ?? "/profile/about",
    meta: aboutzincMfAWZ9Meta || {},
    alias: aboutzincMfAWZ9Meta?.alias || [],
    redirect: aboutzincMfAWZ9Meta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/about.vue").then(m => m.default || m)
  },
  {
    name: change_45passwordg8LLVckESDMeta?.name ?? "profile-change-password",
    path: change_45passwordg8LLVckESDMeta?.path ?? "/profile/change-password",
    meta: change_45passwordg8LLVckESDMeta || {},
    alias: change_45passwordg8LLVckESDMeta?.alias || [],
    redirect: change_45passwordg8LLVckESDMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/change-password.vue").then(m => m.default || m)
  },
  {
    name: deleteaccountBnCjo9idmZMeta?.name ?? "profile-deleteaccount",
    path: deleteaccountBnCjo9idmZMeta?.path ?? "/profile/deleteaccount",
    meta: deleteaccountBnCjo9idmZMeta || {},
    alias: deleteaccountBnCjo9idmZMeta?.alias || [],
    redirect: deleteaccountBnCjo9idmZMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/deleteaccount.vue").then(m => m.default || m)
  },
  {
    name: indexxwIcJaofu6Meta?.name ?? "profile",
    path: indexxwIcJaofu6Meta?.path ?? "/profile",
    meta: indexxwIcJaofu6Meta || {},
    alias: indexxwIcJaofu6Meta?.alias || [],
    redirect: indexxwIcJaofu6Meta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: language_45switchs0hyEDi44dMeta?.name ?? "profile-language-switch",
    path: language_45switchs0hyEDi44dMeta?.path ?? "/profile/language-switch",
    meta: language_45switchs0hyEDi44dMeta || {},
    alias: language_45switchs0hyEDi44dMeta?.alias || [],
    redirect: language_45switchs0hyEDi44dMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/language-switch.vue").then(m => m.default || m)
  },
  {
    name: profile_45basics3Cwn3bevgGMeta?.name ?? "profile-profile-basics",
    path: profile_45basics3Cwn3bevgGMeta?.path ?? "/profile/profile-basics",
    meta: profile_45basics3Cwn3bevgGMeta || {},
    alias: profile_45basics3Cwn3bevgGMeta?.alias || [],
    redirect: profile_45basics3Cwn3bevgGMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/profile/profile-basics.vue").then(m => m.default || m)
  },
  {
    name: qrscan_45insideBY5Klx9iVvMeta?.name ?? "qrscan-inside",
    path: qrscan_45insideBY5Klx9iVvMeta?.path ?? "/qrscan-inside",
    meta: qrscan_45insideBY5Klx9iVvMeta || {},
    alias: qrscan_45insideBY5Klx9iVvMeta?.alias || [],
    redirect: qrscan_45insideBY5Klx9iVvMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/qrscan-inside.vue").then(m => m.default || m)
  },
  {
    name: register8FkDhkxA2PMeta?.name ?? "register",
    path: register8FkDhkxA2PMeta?.path ?? "/register",
    meta: register8FkDhkxA2PMeta || {},
    alias: register8FkDhkxA2PMeta?.alias || [],
    redirect: register8FkDhkxA2PMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/register.vue").then(m => m.default || m)
  },
  {
    name: startsYhkcPakvKMeta?.name ?? "start",
    path: startsYhkcPakvKMeta?.path ?? "/start",
    meta: startsYhkcPakvKMeta || {},
    alias: startsYhkcPakvKMeta?.alias || [],
    redirect: startsYhkcPakvKMeta?.redirect || undefined,
    component: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/pages/start.vue").then(m => m.default || m)
  }
]